export default __webpack_public_path__ + "static/hacktoberfest2022-cf3234a858de53f76f2f2c66f5bc1a67.webp";